import { CountFaxesResponse } from '@weave/schema-gen-ts/dist/schemas/fax/v1/fax.pb';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { useQueryClient } from 'react-query';
import { FaxQueries } from '@frontend/api-fax';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxCountEventSubscription = () => {
  const queryClient = useQueryClient();

  return useWebsocketEventSubscription(NotificationType.FAX_COUNT_CHANGE, (payload) => {
    if (payload.params.unreadFaxCount === undefined) return;
    queryClient.setQueriesData<CountFaxesResponse>({ queryKey: [...FaxQueries.queryKeys.base, 'count'] }, (old) => {
      if (!old) return old as unknown as CountFaxesResponse;
      return { ...old, faxCount: payload.params.unreadFaxCount! };
    });
  });
};
